import axios from 'axios/index';
import { MODERATORS_NOT_ATTACHED } from '../../utils/constants';

const getModeratorsNotAttached = async (hash, agentId) => { // queries === object

    return await axios.get(MODERATORS_NOT_ATTACHED(agentId), {
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/pdf",
            "Accept-language": "bg",
            "Authorization": hash,
        }
    }).then(resp => {
        return resp.data;
    }).catch(err => {
        console.error(err)
    })

}

export default getModeratorsNotAttached;